export default __webpack_public_path__ + "static/media/Avatar-12.4193e4e9.png";